import { useEffect, Fragment } from "react";
import { SnackbarProvider, useSnackbar } from "notistack";
import { cleatNotification } from "../../store/thunk/commonThunk";
import { useAppDispatch, useAppSelector } from "../../store/store";

function SnackBatApp() {
  const dispatch = useAppDispatch();
  const { message, status, type } = useAppSelector(
    (state) => state.notificationSlice
  );
  const { enqueueSnackbar } = useSnackbar();
  const FaildMessageArr = [
    "Something went wrong",
    "Something went wrong!",
    "Something is wrong",
    "Something Went Wrong",
  ];

  useEffect(() => {
    if (status === true) {
      type === "warning"
        ? enqueueSnackbar(message, { variant: "warning" })
        : enqueueSnackbar(message, { variant: "success" });
    }
    if (status === false) {
      const newMsgArr = ["Data Not Found"];
      if (message && !FaildMessageArr.includes(message)) {
        enqueueSnackbar(message, {
          variant: "error",
          autoHideDuration: newMsgArr?.includes(message) ? 1000 : 3000,
        });
      }
    }
    dispatch(cleatNotification({}));
  }, [message, status]);

  return <Fragment></Fragment>;
}

export default function SnackBat() {
  return (
    <SnackbarProvider
      maxSnack={1}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      autoHideDuration={4000}
    >
      <SnackBatApp />
    </SnackbarProvider>
  );
}
